import { ReactNode, useMemo, useState } from "react";
import { AppContext, AppContextValue } from "../contexts/app-context";
import { ExamConfiguration } from "../hooks/use-exam-config-mapping";

interface AppContextProviderProps {
  children?: ReactNode;
}

function AppContextProvider({ children }: AppContextProviderProps) {
  const [examConfig, setExamConfig] = useState<ExamConfiguration>();
  const [candidateInfo, setCandidateInfo] = useState<any>();

  const setExamConfigState = (config: ExamConfiguration) => {
    setExamConfig(config);
  };

  const setCandidateInfoState = (candidateInfo: any) => {
    setCandidateInfo(candidateInfo);
  };

  const contextValue = useMemo<AppContextValue>(
    () => ({
      examConfig: examConfig,
      candidateInfo: candidateInfo,
      setExamConfig: setExamConfigState,
      setCandidateInfo: setCandidateInfoState,
    }),
    [examConfig, candidateInfo],
  );

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
}

export default AppContextProvider;
